var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("JoinPrivateRoom", { attrs: { "room-name": _vm.roomName } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }